import React from "react";
import Navbar from "../components/Navbar";
import "../styles/global.css";
import Partner from "../components/Partner";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet-async";

const PartnerPage = () => {
  return (
    <>
      <Helmet>
        <title>Become Partner | TimeWatch Infocom</title>
        <meta
          name="description"
          content="Partner with TimeWatch Infocom, a leading provider of biometric solutions, access control systems, and smart security technologies. Join our network of trusted partners to offer cutting-edge security solutions, including time attendance systems, entrance automation, and parking management. As a partner, you'll benefit from our innovative products, industry expertise, and strong market presence. Explore partnership opportunities with TimeWatch Infocom to expand your business while delivering reliable and advanced security technology solutions to clients worldwide."
        />
        <link
          rel="canonical"
          href="https://www.timewatchindia.com/become-partner"
        />
      </Helmet>
      <header className="navbar">
        <Navbar />
      </header>

      <div className="content-container">
        <section className="partner">
          <Partner />
        </section>
      </div>

      <footer className="footer">
        <Footer />
      </footer>
    </>
  );
};

export default PartnerPage;
